import { useStore } from 'vuex'
import { ref } from 'vue'
import Editor from '@hugerte/hugerte-vue'
import { useHugeRTE } from '../../foundation/js/loadHugeRTE'
import FormInputTextField from 'components/FormInputTextField/FormInputTextField.vue'

export default {
    name: "CreateGallery",
    components: {
        FormInputTextField,
        Editor
    },
    props: {
        groupName: {
            type: String,
            required: true,
            default: ""
        },
        groupId: {
            type: String,
            required: true
        },
        content: {
            type: Object,
            required: false,
            default: null
        }
    },
    setup(props) {
        const store = useStore()
        const getLabel = (labelKey, replacements) => {
            let label = store.getters['labels/getLabel']({ labelCollection: 'createGallery', labelKey: labelKey })
            if (replacements) {
                replacements.forEach((replacement, index) => {
                    label = label.replace(`{${index}}`, replacement)
                })
            }
            return label
        } 

        const galleryTitle = ref(props.content?.title)
        const galleryContent = ref(props.content?.description)
        const galleryImages = ref(props.content?.files)
        const showInputErrors = ref(false)
        const { editorReady } = useHugeRTE()

        const onFileChange = (e) => {
            const files = e.target.files
            Array.from(files).forEach(file => {
                let newFile = file
                newFile.url = URL.createObjectURL(file)
                galleryImages.value.push(newFile)
            })
        }

        const removeFile = (fileName) => {
            galleryImages.value = Array.from(galleryImages.value).filter(image => image.name !== fileName)
            
        }
        
        const submitCreateGallery = async function () {
            showInputErrors.value = true
            if (galleryTitle.value !== "" && galleryContent.value !== "" && (props.isGallery ? galleryImages.value.length > 0 : true)) {
                const body = {
                    title: galleryTitle.value,
                    content: galleryContent.value,
                    images: galleryImages.value
                }

                const response = !props.content
                    ? await store.dispatch('forum/submitCreateGallery', {
                        body: body,
                        id: props.groupId
                    })
                    : await store.dispatch('forum/submitEditGallery', {
                        body: body,
                        id: props.groupId
                    })

                if (response.continueUrl) {
                    window.location.href = response.continueUrl
                }
            }   
        }

        return {
            getLabel,
            galleryTitle,
            galleryContent,
            galleryImages,
            showInputErrors,
            submitCreateGallery,
            removeFile,
            onFileChange,
            editorReady
        }
    }
}